// extracted by mini-css-extract-plugin
export default {"list":"Home_list__85lHp","spinner":"Home_spinner__-Uw6c","map":"Home_map__QB-T9"};